import { ref, readonly } from 'vue';

const _isVisibleModalPolicy = ref(false);
const _policyCurrent = ref('');

export const useModalPolicy = () => {
  const isVisibleModalPolicy = readonly(_isVisibleModalPolicy);
  const policyCurrent = readonly(_policyCurrent);

  const openModalPolicy = () => {
    _isVisibleModalPolicy.value = true;
  };

  const closeModalPolicy = () => {
    _isVisibleModalPolicy.value = false;
  };

  const setPolicyCurrent = (newVal: string) => {
    _policyCurrent.value = newVal;
  };

  return {
    isVisibleModalPolicy,
    policyCurrent,
    openModalPolicy,
    closeModalPolicy,
    setPolicyCurrent,
  };
};
